const advancedDiagnosticCodes = {
  A101: "A101",
  Good: "Good",
  A999: "A999",
  B038: "B038",
  B032: "B032",
  B102: "B102",
  B004: "B004",
  C002: "C002",
  B103: "B103",
  B043: "B043",
  C027: "C027",
  B050: "B050",
  B051: "B051",
  B067: "B067",
  B006: "B006",
  B999: "B999",
  defective: "defective",
  Undefined: "Undefined",
  Unknown: "Unknown",
  Failed: "Failed",
};

export default advancedDiagnosticCodes;
